import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BeerCcButtonProvider } from '../beer-cc-button/beer-cc-button';
/*
  Generated class for the BeerCcSearchProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class BeerCcSearchProvider {

  private buttons: Array<any>;

  constructor(public http: HttpClient, private beerCcButtonProvider: BeerCcButtonProvider) {
    console.log('Hello BeerCcSearchProvider Provider');
    this.buttons = beerCcButtonProvider.getButtons();
  }
  public getButtons(): Array<any> {
    return this.buttons;
  }


}
